import { TabSwitch, VStack } from '@genial/components';
import { Spacing } from '@genial/design-tokens';
import { Box } from 'native-base';
import React from 'react';

import { CardHero } from './components/CardHero';
import { HeaderSection } from './components/HeaderSection';

import { TradingDetailsTypes } from '.';

export const TradingDetailsMobile: React.FC<TradingDetailsTypes.Content> = ({
  selectedTab,
  handleTabPress,
  tabs,
  accountId,
  handleRefresh,
}) => {
  return (
    <VStack
      px={Spacing['inline.xxxs']}
      alignSelf={'center'}
      minHeight="fit-content"
      width="100%"
      flex={1}>
      <HeaderSection handleRefresh={handleRefresh} title="Detalhes do cliente" />
      <CardHero accountId={accountId} />
      <Box pt={Spacing['inset.xs']}>
        <TabSwitch
          testId="tab-switch"
          tabs={tabs}
          selectedTab={selectedTab}
          onTabPress={handleTabPress}
          isLoading={false}
          isMobile={true}
        />
      </Box>
    </VStack>
  );
};

TradingDetailsMobile.displayName = 'TradingDetailsMobile';
